import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';

const TIPO_LABEL: Record<string, string> = {
  hpg: 'HPG',
  coprocultivo: 'Coprocultivo',
  baermann: 'Baermann',
  sedimentacion_fh: 'Sedimentación Fh',
  ectoparasitos: 'Ectoparásitos',
};

interface AnalisisFormPlaceholderDialogProps {
  open: boolean;
  onClose: () => void;
  tipo: string;
}

export function AnalisisFormPlaceholderDialog({
  open,
  onClose,
  tipo,
}: AnalisisFormPlaceholderDialogProps): JSX.Element {
  const label = TIPO_LABEL[tipo] ?? tipo;

  return (
    <Dialog open={open} maxWidth="sm" fullWidth onClose={onClose}>
      <DialogTitle>Carga de {label}</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ textAlign: 'center', py: 2 }}>
          Este formulario aún no fue implementado. Pendiente para un próximo prompt.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cerrar</Button>
      </DialogActions>
    </Dialog>
  );
}
